(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["appliance-common-issues"] && !Shopify.designMode) return;
  try {
    (function () {
    function debounce(fn, delay) {
      var timer = null;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(fn, delay);
      };
    }

    document.querySelectorAll('.issues-carousel').forEach(function (carousel) {
      var track = carousel.querySelector('.issues-track');
      var prevBtn = carousel.querySelector('.issues-nav--prev');
      var nextBtn = carousel.querySelector('.issues-nav--next');
      var status = carousel.parentElement ? carousel.parentElement.querySelector('.issues-status') : null;
      var cards = track ? Array.from(track.querySelectorAll('.issue-card')) : [];
      if (!track || !prevBtn || !nextBtn || !cards.length) return;

      function cardStep() {
        var gap = parseFloat(getComputedStyle(track).columnGap || '0');
        return cards[0].getBoundingClientRect().width + gap;
      }

      function updateNavState() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = maxScroll <= 1 || track.scrollLeft >= maxScroll - 1;
      }

      function announcePosition() {
        if (!status) return;
        var index = Math.round(track.scrollLeft / cardStep());
        index = Math.max(0, Math.min(index, cards.length - 1));
        status.textContent = 'Issue ' + (index + 1) + ' of ' + cards.length;
      }

      var debouncedUpdate = debounce(function () {
        updateNavState();
        announcePosition();
      }, 120);

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', debouncedUpdate);
      window.addEventListener('resize', debouncedUpdate);
      updateNavState();
      announcePosition();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
